import React from 'react';
import { Star, ShieldCheck, Globe } from 'lucide-react';
import { Button } from './ui/Button';
import { HERO_IMAGE } from '../utils/heroImage';
export function Hero() {
  return <section className="relative pt-12 pb-20 md:pt-20 md:pb-32 overflow-hidden bg-stadium-glow" data-id="element-79" data-mp="9ktefowaq4ya">
      <div className="container mx-auto px-4 relative z-10" data-id="element-80" data-mp="4lqkp0lrnl5m">
        <div className="max-w-5xl mx-auto text-center" data-id="element-81" data-mp="4n9wof0e3a1l">
          <div data-id="element-82" data-mp="12a0l5b5wm0um">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-navy-800/80 border border-gold-500/30 text-gold-400 font-oswald uppercase tracking-widest text-sm mb-6 backdrop-blur-sm" data-id="element-83" data-mp="128fsjr35grze">
              <span className="w-2 h-2 rounded-full bg-gold-500 animate-pulse" data-id="element-84" data-mp="s9zwrat6gujk"></span>
              SYSTÈME D'ENTRAÎNEMENT ÉPROUVÉ
            </div>

            <h1 className="font-anton text-5xl md:text-7xl lg:text-8xl text-white uppercase tracking-wide leading-[1.1] mb-6 drop-shadow-2xl" data-id="element-85" data-mp="3d1im5e7m7kpj">
              Arrêtez de Planifier Pendant des Heures. Créez Toute Votre Saison
              de Football en{' '}
              <span className="text-gold-500" data-id="element-86" data-mp="3j923tk0h7itf">Moins de 5 Minutes</span>
            </h1>

            <p className="text-lg md:text-2xl text-gray-300 max-w-3xl mx-auto mb-10 font-medium leading-relaxed" data-id="element-87" data-mp="3o6aqnxwkkb10">
              Gagnez du temps, réduisez le stress et formez de meilleurs joueurs
              de football — sans passer des heures à planifier vos séances
              d'entraînement à partir de zéro.
            </p>
          </div>

          <div className="relative mb-12 group" data-id="element-88" data-mp="358reiletecad">
            <div className="absolute -inset-4 bg-gradient-to-r from-gold-500/20 via-green-500/20 to-gold-500/20 rounded-2xl blur-2xl opacity-50 group-hover:opacity-70 transition-opacity duration-500" data-id="element-89" data-mp="359j8jrsrk1yj"></div>
            <img src={HERO_IMAGE} alt="Football Prêt : Système 365 — 6 volumes + 5 bonus" width={1536} height={1024} loading="eager" fetchPriority="high" decoding="sync" style={{
            aspectRatio: '1536 / 1024'
          }} className="relative block w-full h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-90" data-mp="2vjg670zr5bnj" />
          </div>

          <div className="flex flex-col items-center gap-6" data-id="element-91" data-mp="id9ri70fbzqn">
            <Button size="xl" onClick={() => document.getElementById('offer')?.scrollIntoView({
            behavior: 'smooth'
          })} data-id="element-92" data-mp="ddf3cb819o9a">
              OUI, JE VEUX MON SYSTÈME MAINTENANT
            </Button>

            <div className="flex flex-col items-center gap-3" data-id="element-93" data-mp="112g55fmd215l">
              <div className="flex items-center gap-1" data-id="element-94" data-mp="110wq1scfxw5e">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-500 text-gold-500" data-id="element-95" data-mp="x37cyf6yybc5" data-mpi={i} />)}
                <span className="ml-2 font-oswald text-lg text-gray-200" data-id="element-96" data-mp="3hqahwlxb75jg">
                  4.9/5 — Avis Vérifiés&nbsp; | &nbsp;Utilisé par plus de 3 000
                  Entraîneurs de Football dans le Monde
                </span>
              </div>

              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-97" data-mp="218jubsgqob1s">
                <ShieldCheck className="w-4 h-4 text-green-500" data-id="element-98" data-mp="267wlgpen84a6" />
                <span data-id="element-99" data-mp="2b1hiof8ewu8b">
                  Garantie Satisfait ou Remboursé 7 Jours — Zéro Risque
                </span>
              </div>

              <div className="flex items-center gap-2 text-gray-400 text-sm font-medium" data-id="element-100" data-mp="2g257cu964yzd">
                <Globe className="w-4 h-4 text-gold-500" data-id="element-101" data-mp="2l1012r8oc7y9" />
                <span data-id="element-102" data-mp="2p1jyzx12nflg">Payez Dans Votre Devise Locale</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}